// Minimal RFC-4180 CSV encoder/decoder.
// Quotes fields that contain comma, quote, CR or LF. Escapes quotes by doubling.
// Produces a trailing \n. Round-trip: toCSV(headers, fromCSV(toCSV(...))) === original.

function escapeCell(v) {
  const s = v == null ? "" : String(v);
  if (/[",\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

export function toCSV(headers, rows) {
  const lines = [headers.map(escapeCell).join(",")];
  for (const row of rows) {
    lines.push(headers.map((h) => escapeCell(row[h])).join(","));
  }
  return lines.join("\n") + "\n";
}

export function fromCSV(text) {
  // Normalise line endings
  const src = text.replace(/\r\n?/g, "\n");
  const rows = [];
  let i = 0;
  let field = "";
  let row = [];
  let inQuotes = false;
  while (i < src.length) {
    const c = src[i];
    if (inQuotes) {
      if (c === '"') {
        if (src[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      field += c; i++; continue;
    }
    if (c === '"') { inQuotes = true; i++; continue; }
    if (c === ",") { row.push(field); field = ""; i++; continue; }
    if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; i++; continue; }
    field += c; i++;
  }
  // Flush last field if file did not end with \n
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
  if (rows.length === 0) return { headers: [], data: [] };
  const headers = rows[0];
  const data = rows.slice(1)
    .filter((r) => r.length > 0 && !(r.length === 1 && r[0] === ""))
    .map((r) => {
      const obj = {};
      headers.forEach((h, idx) => { obj[h] = r[idx] ?? ""; });
      return obj;
    });
  return { headers, data };
}

export function downloadCSV(filename, content) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function parseMaybeJSON(cell, fallback) {
  if (cell == null || cell === "") return fallback;
  try {
    const v = JSON.parse(cell);
    return v == null ? fallback : v;
  } catch {
    return fallback;
  }
}
